import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@cotyorg/ccx-atoms/Picture';

const CardoImageElement = ({
  src,
  alt,
  srcset,
  cover,
  fixedHeight,
  doNotLazyLoad,
  imageDecode,
  disableProgressiveLoading,
}) => (
  <Picture
    src={src}
    srcset={srcset}
    alt={alt}
    cover={cover}
    wrapperExtraClass={(cover && fixedHeight) ? 'picture-wrapper--fixed-height' : ''}
    doNotLazyLoad={doNotLazyLoad}
    imageDecode={imageDecode}
    disableProgressiveLoading={disableProgressiveLoading}
  />
);

CardoImageElement.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  srcset: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  cover: PropTypes.bool,
  fixedHeight: PropTypes.bool,
  doNotLazyLoad: PropTypes.bool,
  imageDecode: PropTypes.string,
  disableProgressiveLoading: PropTypes.bool,
};

export default CardoImageElement;
